import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { APICONSTANTS } from "../../constants/api-constants";
import { SeuilModel } from "../../models/simple-types/seuil.model";
import { GenericLibelleService } from "../basic/generic-libelle.service";
import { HostnameService } from "../basic/hostname.service";

@Injectable()
export class SeuilService extends GenericLibelleService<SeuilModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTESEUIL, hostnameService);
  }

  GetSeuilByCa1(codeCa1: string, idSociete: any, type: string): Observable<SeuilModel> {
    // tslint:disable-next-line
    return this.http.get<SeuilModel>(APICONSTANTS.URLAPI.value + this.route + 'GetSeuilByCa1?codeCa1=' + codeCa1 + '&idSociete=' + idSociete + '&type=' + type)
    .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }
}
